// components/ui/LaptopMockup.tsx
import React from "react";
import { StyleSheet, View, useWindowDimensions } from "react-native";

type Props = { children: React.ReactNode };

export default function LaptopMockup({ children }: Props) {
  const { height } = useWindowDimensions();

  // ✅ Taller screen -> card looks full and premium
  const screenH = Math.min(700, Math.max(540, height - 220));

  return (
    <View style={styles.wrap}>
      <View style={styles.bezel}>
        <View style={[styles.screen, { height: screenH }]}>{children}</View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: { width: "100%", alignItems: "center" },

  // ✅ No black border
  bezel: {
    width: "100%",
    maxWidth: 1100,
    borderRadius: 28,
    padding: 0,
    backgroundColor: "transparent",
    shadowColor: "#000",
    shadowOpacity: 0.14,
    shadowRadius: 22,
    shadowOffset: { width: 0, height: 14 },
    elevation: 8,
  },

  // ✅ Full-height screen area
  screen: {
    width: "100%",
    borderRadius: 18,
    overflow: "hidden",
    backgroundColor: "#e9edf5",
    padding: 10,
  },
});
